import React, { useState, useEffect, useCallback, useRef } from "react";
import { useDispatch, useSelector } from 'react-redux';
import * as actions from '../../store/actions';
import { useHistory, withRouter } from 'react-router-dom'
import { i18n } from '../../translate/i18n';
import { withStyles } from '@mui/styles';
import { Avatar } from '@mui/material';
import { sortBy } from 'lodash';

import AddIcon from '@mui/icons-material/AddCircle';

import {
  Appbar,
} from '../Login/styles';
import { rolesText } from "../../utils/roleNames";
import { blue } from "@mui/material/colors";
import Spinner from "../../components/Spinner/index";

const TenantSelector = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  let textInput = useRef(null);

  const [page, setPage] = useState(1);
  const [alreadySerched, setAlreadySerched] = useState(false);
  const [limit, setLimit] = useState(100);
  const [searchText, setSearchText] = useState("");
  const [orderBy, setOrderBy] = useState("name");
  const [order, setOrder] = useState("asc");

  const access = useSelector(state => state.auth.access)
  const superadmin = useSelector(state => state.auth.superadmin)
  const loading = useSelector(state => state.auth.loading)

  const selectTenantCard = (acc) => {
    if (acc.active === false) return;
    if (acc._id === 1) {
      props.history.push(`/tenants`)
    } else {
      localStorage.setItem('selectedTenant', acc.tenant._id);
      dispatch(actions.selectTenantAccess(acc))
      const redirectTo = localStorage.getItem('redirectTo');
      if (redirectTo) {
        localStorage.removeItem('redirectTo');
        return history.push(redirectTo);
      }
      props.history.push(`/`)
    }
  }

  useEffect(() => {
    localStorage.removeItem('selectedTenant');
    if (access.length === 0) {
      localStorage.removeItem('selectedTenant');
      dispatch(actions.getMe()).then(res => {
        console.log('res', res);
        if (res === 'error') {
          localStorage.removeItem('token');
          localStorage.removeItem('selectedTenant');
          props.history.push('/login');
        }
      })
    }
  }, [])

  const card = (acc) => (
    <div
      style={styles.cardContainer}
      className={props.classes.hoverCard}
      key={acc._id}
      onClick={() => selectTenantCard(acc)}>
      {acc.tenant.photo ? <Avatar src={acc.tenant.photo.url} style={styles.avatar} /> : <Avatar style={styles.avatarSmallText}>LOGO</Avatar>}
      <div style={styles.cardBody}>
        <span style={styles.nameText}>{acc.tenant.name}</span>
        <span style={styles.roleText}>{rolesText(acc)}</span>
      </div>
      {acc.active === false && <span style={styles.notActiveBadge}>{i18n.t('divTenantSelector.notActiveBadge')}</span>}
      {acc.tenant.blocked === true && <span style={styles.notActiveBadge}>{i18n.t('divTenantSelector.blocked')}</span>}
    </div>
  )

  return (
    <>
      <Appbar showLogo={true} />
      <div style={styles.container}>
        {loading && <Spinner overlay />}
        {!loading && access.length === 0 && <div>{i18n.t('divTenantSelector.access')}</div>}
        {sortBy(access, [(ac) => ac.tenant.name]).map(acc => (
          card(acc)
        ))}
        {superadmin && card({
          _id: 1,
          role: 'superadmin',
          tenant: {
            name: 'Area de administração'
          }
        })}
      </div>
    </>
  )
}

const classes = {
  hoverCard: {
    cursor: "pointer",
    "&:hover": {
      boxShadow: "-4px 3px 14px -4px #bbb",
      border: "2px solid #3f51b5",
    }
  },
}


export default withStyles(classes)(withRouter(TenantSelector));

const styles = {
  container: {
    marginTop: 90,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    width: "100%",
    flex: 'grow'
  },
  cardContainer: {
    display: 'flex',
    flexDirection: 'row',
    border: "1px solid #ccc",
    padding: "10px 20px",
    borderRadius: "10px",
    width: "80%",
    maxWidth: "400px",
    margin: 5,
    position: "relative",
  },
  avatar: {
    width: 50,
    height: 50,
  },
  avatarSmallText: {
    fontSize: 12,
    width: 50,
    height: 50,
  },
  cardBody: {
    display: "flex",
    justifyContent: "center",
    paddingLeft: 10,
    flexDirection: 'column'
  },
  roleText: {
    fontSize: 12
  },
  nameText: {
    fontWeight: "bold"
  },
  notActiveBadge: {
    position: 'absolute',
    top: 10,
    right: 10,
    backgroundColor: "#f44336",
    padding: "5px 10px",
    borderRadius: 10,
    fontSize: 12,
    color: "#fff",
    fontWeight: "bold"
  }
}